// extracted by mini-css-extract-plugin
export default {"image":"MainTasksHeader_image__mOOwp","title":"MainTasksHeader_title__6d9nv","titleWrapper":"MainTasksHeader_titleWrapper__G6fRp","notEnglish":"MainTasksHeader_notEnglish__EJfCJ"};